import { RimCertificateAppType } from "../enums"
import { RimDetailsArticle } from "../model"

export function getRimCertificateAppType(article: RimDetailsArticle | undefined, certificatType: RimCertificateAppType): boolean {
    if (!article) {
        return false
    }

    return getAppTypeID(article.appTypeID) === certificatType
}

function getAppTypeID(appTypeID: string) {
    switch (appTypeID) {
        case "1":
            return RimCertificateAppType.TGA
        case "2":
            return RimCertificateAppType.ABE
        case "3":
            return RimCertificateAppType.ECE
        case "8":
            return RimCertificateAppType.TTG
        default:
            return ""
    }
}
